import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../Store/AuthContext";

export const CheckLanguageSelectedResetPassowrd = () => {
  const { state } = useAuth();
  const location = useLocation();

  const path = location.pathname;

  const urlparams = new URLSearchParams(location.search);
  const expireTime = urlparams.get("expiretime");
  const lan = urlparams.get("lan");

  return path.includes("forgot-password") && !state.lang.code ? (
    <Navigate
      to={"/signin/select-language"}
      state={{
        pageName: "forgot-password",
        url: `${location.pathname}${location.search}`,
      }}
    />
  ) : path.includes("reset-password") &&
    expireTime &&
    new Date() > new Date(expireTime) ? (
    <Navigate to={"/contact-support"} state={{ lan: lan }} />
  ) : (
    <Outlet />
  );
};
